<script setup lang="ts">
import RadioButton from "~/components/inputs/RadioButton.vue";
import FormCard from "~/components/ui/FormCard.vue";
import { useFormContainer } from "~/composables/useFormContainer";
import BackButton from "~/components/inputs/BackButton.vue";

import Validator from "~/utils/validator";

import { useVuelidate } from "@vuelidate/core";
const locale = await getLocale("forms", "credit_risk");
import creditRiskFormRules from "~/rules/creditRisk";
import Perks from "~/components/static/Perks.vue";

defineComponent({
  name: "CreditRisk",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "goBack"]);

const financialProblems = useState<boolean | null>(
  "financialProblems",
  () => null,
);

const v$ = useVuelidate(creditRiskFormRules, { financialProblems });

const validate = () => {
  v$.value.$touch();
  v$.value.$validate();
  return !v$.value.$error;
};

const submit = () => {
  if (validate()) {
    emit("submit");
  }
};
onMounted(() => emit("init"));
</script>

<template>
  <FormContainer :progress="progress">
    <FormCard :title="locale.title" @submit="submit">
      <div class="w-full mb-6 ">
        <div class="flex flex-col items-center justify-center">
          <label class="pageSubtitle pb-6" id="credit-risk-label" v-html="locale.text" />
          <RadioButton
            v-model="financialProblems"
            :values="yesNoOptions"
            :error="v$.financialProblems.$error"
            :error-message="Validator.message(v$.financialProblems)"
            data-testid="financialProblems"
            label-id="credit-risk-label"
          />
        </div>
      </div>
      <template #link>
        <BackButton :event="`goBack`" @go-back="$emit('goBack')" />
      </template>
    </FormCard>
  </FormContainer>
  <Perks />
</template>

<style scoped></style>
